import { useApp, useAuth } from 'hooks'
import { CalendarDays, Cloud } from 'lucide-react'
import { Dropdown } from 'react-bootstrap'
import { NavLink } from 'react-router'
import './MenuBar.scss'

function MenuBar() {
  const { allowedRoutes } = useAuth()
  const { availableYears, selectedYear, setSelectedYear } = useApp()

  return (
    <nav className="menu-bar container-fluid px-5 py-4">
      <div className="d-flex align-items-center gap-3">
        <h5 className="menu-bar__title">
          <div>
            <Cloud size={24} color="var(--blue)" />
          </div>
          CLOUD SPENDING
        </h5>
        <Dropdown>
          <Dropdown.Toggle variant="primary" className="d-flex align-items-center">
            <CalendarDays size={18} className="me-2" /> {selectedYear}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {availableYears.map((mapYear) => {
              return (
                <Dropdown.Item
                  key={mapYear}
                  active={mapYear === selectedYear}
                  eventKey={mapYear}
                  onClick={() => {
                    setSelectedYear(mapYear)
                  }}
                >
                  {mapYear}
                </Dropdown.Item>
              )
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div className="menu-bar__items">
        {Object.values(allowedRoutes).map((route) => (
          <NavLink
            key={route.path}
            to={route.path}
            className={({ isActive }) => `menu-bar__link ${isActive ? 'menu-bar__link--active shadow-sm' : ''}`}
          >
            {route.icon && <div>{route.icon}</div>}
            {route.title}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}

export default MenuBar
